import { LocationUtils } from '@ctct/rise-utils';
import { useTranslations } from 'next-intl';
import { type ComponentProps, useMemo } from 'react';

import { type InputOpts } from '../../../types';
import { DropdownInput, type DropdownItem } from '../../inputs-core';

const CountryNameDropdown = ({
  formKey,
  registerOpts,
  ...selectProps
}: InputOpts & ComponentProps<typeof DropdownInput>) => {
  const t = useTranslations('UiForm');
  const emptyValue: DropdownItem = useMemo(
    () => ({ label: t('shared.country.placeholder'), value: '-' }),
    [t]
  );
  const dropdownItems: DropdownItem[] = LocationUtils.countries.map((country) => ({
    label: country.name,
    value: country.name,
  }));
  return (
    <DropdownInput
      formKey={formKey}
      registerOpts={registerOpts}
      placeholder={t('shared.country.placeholder')}
      items={dropdownItems}
      emptyValue={emptyValue}
      {...selectProps}
    />
  );
};

export { CountryNameDropdown };
